import { defineComponent as n, computed as o, openBlock as a, createElementBlock as c, createElementVNode as t, toDisplayString as d, createCommentVNode as _, normalizeStyle as f } from "vue";
const h = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "da8168a1-c817-49de-a301-bd1afa9c9986" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#da8168a1-c817-49de-a301-bd1afa9c9986)" }, k = { key: 0 }, p = /* @__PURE__ */ t("path", {
  fill: "#eee",
  d: "m0 256 249.6-41.3L512 256v256H0z"
}, null, -1), v = /* @__PURE__ */ t("path", {
  fill: "#a2001d",
  d: "M0 0h512v256H0z"
}, null, -1), g = { fill: "none" }, x = ["r"], B = /* @__PURE__ */ n({
  __name: "id",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(i) {
    const e = i, l = o(() => 512 + 2 * e.strokeWidth), s = o(() => -e.strokeWidth), r = o(() => 256 + e.strokeWidth / 2);
    return (w, y) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      t("g", u, [
        e.flagName ? (a(), c("title", k, d(e.flagName), 1)) : _("", !0),
        p,
        v
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: f({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, h));
  }
});
export {
  B as default
};
//# sourceMappingURL=id-eafb8890.js.map
